<template>
    <div class="transform">
        <div class="transform_top">积分转出余额</div>
        <div class="transform_con">
            <div class="transform_con_first am-cf">
                <p class="am-fl">我的积分</p>
                <p class="am-fr">0</p>
            </div>
            <div class="transform_con_second">
                <p class="transform_con_second_tit">转出积分</p>
                <div class="transform_con_second_bottom am-cf">
                    <p class="trans_tit  am-fl">USD </p>
                    <input class="am-fl" placeholder="请输入金额" />
                </div>
            </div>
        </div>
        <button class="transform_but">确认转出</button>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
       
        };
    },
    mounted: function () {},
    methods: {
     
    },
};
</script>

<style scoped>
    .transform{width: 100%;}
    .transform_top{font-size: 18px;color: #000;line-height: 40px; text-align: center;}
    .transform_con{width: 100%;line-height: 35px;}
    .transform_con_first{border-bottom: 1px dashed #999;padding: 0px 30px;}
    .transform_con_first p{font-size: 16px;}
    .transform_con_second{width: 100%;border-bottom: 1px dashed #999;}
    .transform_con_second_tit{padding: 0px 30px;font-size: 16px;}
    .trans_tit{font-size: 18px;}
    .transform_con_second_bottom{padding: 0px 30px;display: flex;}
    .transform_con_second_bottom input{font-size: 16px;}
    .transform_but{width: 60%;height: 45px;background-color: var(--bg-color);display: block;margin: 0 auto;font-weight: bold;border-radius: 8px;margin-top: 30px!important;font-size: 16px;color: #fff;}
</style>

